module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/General/Hidden-7befde4965395fc01e912034a439d1dc.svg";